module.exports = __webpack_public_path__ + "img/Feature.018d04b8.png";